// src/stockx/base/EllipsisIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var EllipsisIcon = ({ colorized, ...props }) => /* @__PURE__ */ jsxs(Icon, { viewBox: "0 0 50 50", ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M38.2998 29.5C40.7851 29.5 42.7998 27.4853 42.7998 25C42.7998 22.5147 40.7851 20.5 38.2998 20.5C35.8145 20.5 33.7998 22.5147 33.7998 25C33.7998 27.4853 35.8145 29.5 38.2998 29.5Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11.7002 29.5C14.1855 29.5 16.2002 27.4853 16.2002 25C16.2002 22.5147 14.1855 20.5 11.7002 20.5C9.21491 20.5 7.2002 22.5147 7.2002 25C7.2002 27.4853 9.21491 29.5 11.7002 29.5Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M25 29.5C27.4853 29.5 29.5 27.4853 29.5 25C29.5 22.5147 27.4853 20.5 25 20.5C22.5147 20.5 20.5 22.5147 20.5 25C20.5 27.4853 22.5147 29.5 25 29.5Z",
      fill: colorized ? "black" : "currentColor"
    }
  )
] });
var EllipsisIcon_default = EllipsisIcon;

export {
  EllipsisIcon_default
};
